import { defineMessages } from 'react-intl';

export default defineMessages({
  singularTitle: {
    id: 'simulated.correctionUploadEssaySheetModal.singularTitle',
    defaultMessage: 'ESSAY SHEET UPLOAD',
  },
  pluralTitle: {
    id: 'simulated.correctionUploadEssaySheetModal.pluralTitle',
    defaultMessage: 'ESSAY SHEETS UPLOAD',
  },
  cancel: {
    id: 'simulated.correctionUploadEssaySheetModal.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'simulated.correctionUploadEssaySheetModal.continue',
    defaultMessage: 'Continue',
  },
  loading: {
    id: 'simulated.correctionUploadEssaySheetModal.loading',
    defaultMessage:
      '<div style="display:flex">Please wait... <span class="loading show simple"></span></div>',
  },
  uploadInfo: {
    id: 'simulated.correctionUploadEssaySheetModal.uploadInfo',
    defaultMessage: 'Drag and drop your file',
  },
  uploadInfoClick: {
    id: 'simulated.correctionUploadEssaySheetModal.uploadInfoClick',
    defaultMessage: 'or click here',
  },
  dragDrop: {
    id: 'classesStudents.addClassModal.dragDrop',
    defaultMessage: 'Drag and drop file to upload',
  },
  clickHere: {
    id: 'classesStudents.addClassModal.clickHere',
    defaultMessage: 'or click here',
  },
  alreadyAddedComposing: {
    id: 'classesStudents.addClassModal.alreadyAddedComposing',
    defaultMessage: 'Essay sheets {files} have already been loaded:',
  },
  invalidExtension: {
    id: 'simulated.correctionUploadEssaySheetModal.invalidExtension',
    defaultMessage: 'Invalid file extension',
  },
  errorIntergrationDataNotFound: {
    id: 'simulated.correctionUploadEssaySheetModal.errorIntergrationDataNotFound',
    defaultMessage: 'Integration data not found.',
  },
  errorNoPermission: {
    id: 'simulated.correctionUploadEssaySheetModal.errorNoPermission',
    defaultMessage: 'This student does not have permission for that school.',
  },
  errorGeneric: {
    id: 'simulated.correctionUploadEssaySheetModal.errorGeneric',
    defaultMessage: 'Error loading essay sheet',
  },
  errorUploadingFile: {
    id: 'simulated.correctionUploadEssaySheetModal.errorUploadingFile',
    defaultMessage: 'Error while uploading the file to the server',
  },
  errorIntegratingFile: {
    id: 'simulated.correctionUploadEssaySheetModal.errorIntegratingFile',
    defaultMessage: 'Error while integrating file',
  },
  errorUploadingFileToStudent: {
    id: 'simulated.correctionUploadEssaySheetModal.errorUploadingFileToStudent',
    defaultMessage: 'Error while uploading the file. Try again uploading the file to the student',
  },
  uploading: {
    id: 'simulated.correctionUploadEssaySheetModal.uploading',
    defaultMessage: 'Sending...',
  },
  uploadedSuccess: {
    id: 'simulated.correctionUploadEssaySheetModal.uploadedSuccess',
    defaultMessage: 'Successfully uploaded',
  },
});
